"use client";

import { SessionProvider } from "next-auth/react";
import posthog from "posthog-js";
import { PostHogProvider as PHProvider } from "posthog-js/react";
import { useEffect } from "react";

import PostHogPageView from "./PostHogPageView";

export function Providers({ children }: { children: React.ReactNode }) {
    useEffect(() => {
        posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY as string, {
            api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST,
            person_profiles: "identified_only",
            capture_pageview: false,
            capture_pageleave: true,
            debug: false,
            // loaded: (posthog) => {
            //     if (process.env.NEXT_PUBLIC_ENVIRONMENT === "staging")
            //         posthog.debug();
            // },
        });
    }, []);

    return (
        <SessionProvider>
            <PHProvider client={posthog}>
                <PostHogPageView />
                {children}
            </PHProvider>
        </SessionProvider>
    );
}
